import Description from "@/components/common/Description";
import { services as s } from "@/services";
import { randomHappyEmoji, wordsOfPraise } from "@/utils/positivePatientWords";

interface Props {
	nextEntryDueAt: string;
}

const EntryLocked = ({ nextEntryDueAt }: Props) => {
	return (
		<Description>
			{wordsOfPraise()} {randomHappyEmoji()} Everything is up to date. You will
			be prompted for your next entry at{" "}
			{s.time.formatShortDateTime(nextEntryDueAt)}.
		</Description>
	);
};

export default EntryLocked;
